const inAppMessageDialogKeys = {
  backBuffer: 'back-buffer',
};

export default inAppMessageDialogKeys;
